import React, { Component } from "react";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import PageContent from "@my-dld/components/PageContent";
import Strings from "@my-dld/assets/strings";
import { EjariContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { extractPropInfo } from "../../../component/PropertyHeader";
import EjariPageTitle from "../../../component/EjariPageTitle";
import FormRow from "@my-dld/components/Form/FormRow";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { IdExtractor } from "@my-dld/utils/LookupUtil";
import { Lookup } from "@eres/ejari-api/Entity";
import FormAction from "@my-dld/components/Form/FormAction";
import FormSection from "@my-dld/components/Form/FormSection";
import { FormFieldProps } from "@my-dld/components/Form/FormField";
import { Redirect } from "react-router";
import { StringUtil } from "@eres/core";
import EjariApi from "@eres/ejari-api";
import { LoadableDataState } from "@my-dld/utils/UIUtils";
import { TerminationReasonTransformer } from "@eres/ejari-api/Utils";
import TextInputField from "@my-dld/components/Form/TextInputField";
import DateInputField from "@my-dld/components/Form/DateInputField";
import moment from "moment";
import { TerminateRequest } from "@eres/ejari-api/Entity/contract";

interface Props extends RoutedViewProps<any> {

}

interface LookupState {
	reasons?: Lookup[];
}

interface FormState {
	email?: string;
	date?: Date;
	reason?: Lookup;
	reasonText?: string;

	maxTerminateDate?: Date;
	minTerminateDate?: Date;
}

interface State extends LookupState, FormState, LoadableDataState {
	error?: {},
}

class TerminateContract extends Component<Props, State> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;

	constructor( props: Props ) {
		super( props );
		this.state = {
			loadState: "loading",
			errorContainer: {},
		};
	}

	componentDidMount() {
		EjariApi.getLookup( "TerminationReasons", "", "", TerminationReasonTransformer ).then( reasons => {
			this.setState( { reasons: reasons, loadState: "done" } );
		} );
		const update: Partial<State> = {};
		const contract = this.context.miniContract;
		if ( contract ) {
			update.maxTerminateDate = contract.ContractEndDate!.asDate();
			update.minTerminateDate = contract.ContractStartDate!.asDate();
			let today = moment( new Date() );
			let sd = moment( update.minTerminateDate );
			let ed = moment( update.maxTerminateDate );
			if ( sd.format( "MM-dd-yyyy" ) === "01-01-0001" ) {
				update.minTerminateDate = undefined;
			}
			if ( ed.format( "MM-dd-yyyy" ) === "01-01-0001" ) {
				update.maxTerminateDate = undefined;
			}
			if ( update.maxTerminateDate && update.minTerminateDate ) {
				if ( today.isAfter( update.minTerminateDate ) && today.isBefore( update.maxTerminateDate ) ) {
					update.date = today.toDate();
				} else if ( today.isBefore( update.minTerminateDate ) ) {
					update.date = sd.toDate();
				} else if ( today.isAfter( update.maxTerminateDate ) ) {
					update.date = ed.toDate();
				}
			}
		}
		this.setState( update as State );
	}

	render() {
		const { property, contract, miniContract } = this.context;
		const { reasons, reason, maxTerminateDate, minTerminateDate } = this.state;
		if ( property == null || contract === null || miniContract == null )
			return <Redirect to={ "/mydld" }/>;
		const isValid = this.isValid();
		const filedProps: Partial<FormFieldProps<any>> = {
			holder: this,
			containerClassName: "col-md-6 form-group",
		};
		const { val, lbl } = extractPropInfo( property );
		return <PageContent
			title={ `${ Strings.terminate_contract } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<EjariPageTitle title={ Strings.terminate_contract }/>
			<React.Fragment>
				<FormSection title={ Strings.terminate_contract }>
					<FormRow { ...filedProps } containerClassName="col-md-6 form-group terminate-contract">
						<TextInputField
							error={ this.state.errorContainer.email }
							required={ true }
							label={ Strings.email }
							id={ "email" }
							maxLength={ 256 }
						/>
						<DateInputField
							required={ true }
							label={ Strings.termination_date }
							id={ "date" }
							maxLength={ 256 }
							extraOpts={ {
								maxDate: maxTerminateDate,
								minDate: minTerminateDate,
							} }
						/>
					</FormRow>
					<FormRow { ...filedProps }>
						<PickerInput
							required={ true }
							isLoading={ reasons === undefined }
							id={ "reason" }
							holder={ this }
							toIdentifier={ IdExtractor }
							label={ Strings.termination_reason } items={ reasons }
						/>
						{ reason && reason.Id === -1 &&
							<TextInputField
								error={ this.state.errorContainer.reasonText }
								required={ true }
								label={ Strings.termination_reason }
								id={ "reasonText" }
								maxLength={ 400 }
							/>
						}
					</FormRow>
				</FormSection>
				<FormRow>
					<FormAction
						disablePrimaryAction={ !isValid }
						primaryActionLabel={ Strings.terminate_contract }
						onPrimaryAction={ this.onTerminate }/>
				</FormRow>
			</React.Fragment>
		</PageContent>;
	}

	onTerminate = () => {
		const { email, date, reason, reasonText } = this.state;
		let req: TerminateRequest = {};
		req.AdminEmailAddress = email;
		req.TerminationDate = date?.asServerString();
		req.TerminationReasonId = reason?.Id;
		if ( req.TerminationReasonId === -1 ) {
			req.TerminationReasonText = reasonText;
		}
		req.ActiveUserID = this.context.activeUserId + "";
		req.ActiveUserType = 4;
		req.ContractId = this.context.miniContract?.ContractId + "";
		req.RegistrationContractType = this.context.miniContract?.ContractTypeId;
		this.context.terminateContract( req, this.context ).then( x => {
		} ).catch( e => {
		} );
	};

	isValid = () => {
		const { email, date, reason, reasonText } = this.state;
		let isValid = true;
		isValid = isValid && !StringUtil.isEmptyStringOrNull( email );
		isValid = isValid && StringUtil.isEmailAddress( email! );
		isValid = isValid && date != null && !StringUtil.isEmptyStringOrNull( date.asServerString() );
		isValid = isValid && reason != null;
		if ( isValid ) {
			if ( reason?.Id === -1 ) {
				isValid = isValid && !StringUtil.isEmptyStringOrNull( reasonText );
			}
		}
		return isValid;
	};

}

export default TerminateContract;
